import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Navbar from 'react-bootstrap/Navbar';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';


import DataFiliale from '../components/DataFiliale'

import Imei from '../components/Imei';
import AusstellerListe from '../components/AusstellerListe';
import VerteilungListe from '../components/VerteilungListe';

export default class Home extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          isUserAuthenticated: false,
          exTools: null,
          pCode: '',
          filiale: null,
          filialen: [],
          token: null,
          page: 'home'
        }
    
        this.pcode = null;
        this.token = null;
        this.fetchAddress = '';
        this.fetchBody = '';

        this.changeFiliale = this.changeFiliale.bind(this);
    
      }


    componentDidMount() {
      this.setState({
        filiale: sessionStorage.getItem('filiale'),
        page: this.props.page
      })
    }

    componentDidUpdate() {
    }

    changeFiliale(value) {
      sessionStorage.setItem('filiale', value);
      this.setState({filiale: value});
    }

    onClickExit() {
      sessionStorage.clear();
      window.location.reload(false);
    }

    render() {
      const exTools = JSON.parse(sessionStorage.getItem('exTools'));
      
      const filialen = JSON.parse(sessionStorage.getItem('exFilialen'));

      const filiale = filialen[this.state.filiale];

     //console.log('filiale', filiale);

            const menuMap = {
              imei: {
                name: 'Imei Erfassung',
                content: <Imei />
              },
              aussteller: {
                name: 'Aussteller',
                content: <AusstellerListe />
              },
              verteilung: {
                name: 'Artikel Verteilung',
                content: <VerteilungListe />
              },
              home: {
                name: 'expert Tools',
                content: <Container style={{padding: "5rem 0px 0px 0px"}} className="text-center" >
                      <Row className='mb-3'>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "aussteller" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Aussteller</Link>
                        </Col>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "verteilung" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Bestand<br />Verteilung</Link>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "imei" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Imei<br /> Erfassung</Link>
                        </Col>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "home" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Zwischen<br />Inventur</Link>
                        </Col>
                      </Row>
                    </Container>
              }

            };

            //const filialen = JSON.parse(sessionStorage.getItem('exFilialen'));
            if(filiale) {
              return (
                      <>
                        <Navbar fixed="top" className="bg-body-tertiary justify-content-between" bg="dark" data-bs-theme="dark">
                          <Container fluid>
                            <Navbar.Text>{exTools.MitarbeiterName}</Navbar.Text>
                            {
                              this.state.page === 'home'
                              ? <>
                                  <Navbar.Text>{menuMap[this.state.page].name}</Navbar.Text>
                                  <DataFiliale filialeList={filialen} onChangeFiliale={this.changeFiliale} valueFiliale={this.state.filiale} />
                                  <Navbar.Text onClick={this.onClickExit}><i className="bi bi-box-arrow-right"></i> Logout</Navbar.Text>
                                </>
                              : <>
                                  <Navbar.Text className='text-white'>{menuMap[this.state.page].name} {filiale.bezeichnung || null}</Navbar.Text>
                                  <Navbar.Text onClick={() => {this.setState({ page: "home" })}} className='nav-link'>zurück</Navbar.Text>
                                </>
                            }
                          </Container>
                        </Navbar>     

                        {menuMap[this.state.page].content}
                      </>
              );
            } else {
              return (
                <Container fluid>
                  <Spinner animation="border" role="status" style={{marginTop: '10em'}} />
                </Container>
              );
            }

    }
}